// 'use strict';


var Banner = function(){



};
module.exports = Banner;
